import { createSlice } from "@reduxjs/toolkit";
import {
  fetchItem,
  fetchItemsById,
  updateStatusInItem,
  updateItem,
  fetchAllDropdowns,
  exportItemsCSV,
  // fetchAllDropdownsItems,
} from "./thunk";

interface ItemsState {
  itemList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  exportCSVLoading: boolean;
  exportCSVError: string | null;
  orgDropDown: any[];
  departmentDropDown: any[];
  orgCityDropDown: any[];
  itemsDropDown: any[];

  dropdownOptions: Record<string, any[]>;
}

const initialState: ItemsState = {
  itemList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  exportCSVLoading: false,
  exportCSVError: null,
  dropdownOptions: {},
  orgDropDown: [],
  departmentDropDown: [],
  orgCityDropDown: [],
  itemsDropDown: [],
};

const itemSlice = createSlice({
  name: "items",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All Items
      .addCase(fetchItem.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchItem.fulfilled, (state, action) => {
        state.loading = false;
        state.itemList = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.rowCount =
          typeof action.payload.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch items";
      })

      // Fetch Single Item by ID
      .addCase(fetchItemsById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedOrganisation = action.payload;
      })
      .addCase(fetchItemsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Item
      .addCase(updateItem.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.itemList = state.itemList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update item";
      })

      // Update Status
      .addCase(updateStatusInItem.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.itemList = state.itemList.map((org: any) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateStatusInItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update item status";
      })
      .addCase(exportItemsCSV.pending, (state) => {
        state.exportCSVLoading = true;
        state.exportCSVError = null;
      })
      .addCase(exportItemsCSV.fulfilled, (state) => {
        state.exportCSVLoading = false;
        state.exportCSVError = null;
      })
      .addCase(exportItemsCSV.rejected, (state, action) => {
        state.exportCSVLoading = false;
        state.exportCSVError =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Failed to export CSV";
      });
    // .addCase(fetchAllDropdownsItems.fulfilled, (state, action) => {
    //   state.orgDropDown = action.payload.orgDropDown || [];
    //   state.departmentDropDown = action.payload.departmentDropDown || [];
    //   state.itemsDropDown = action.payload.itemsDropDown || [];
    // });
  },
});

export default itemSlice.reducer;
